import ChatMessageIcon from "./ChatMessageIcon.mjs";

/** @type {GlyphIcon} */
export default ChatMessageIcon;
